// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-37fcb1ba]{margin:0 auto;width:1023px}.content[data-v-37fcb1ba],.no-o[data-v-37fcb1ba]{overflow:hidden}", ""]);
// Exports
module.exports = exports;
